import { BaseDTO } from './basedto';

export class AddPackageLevelTemplateSupplierDTO extends BaseDTO {
    supplierCodesList: string[];
    packageLevelTemplateId: string;

    constructor() {
        super();
    }
}
